import * as z from 'zod';

export const LoanStatusPendingActivation = z.literal('pendingActivation');
export const LoanStatusPreActive = z.literal('preActive');
export const LoanStatusActive = z.literal('active');
export const LoanStatusArchived = z.literal('archived');
export const LoanStatusPendingTransfer = z.literal('pendingTransfer');
export const LoanStatusTransferred = z.literal('transferred');
export const LoanStatusPaidOff = z.literal('paidOff');
export const LoanStatusReo = z.literal('reo');
export const LoanStatusLiquidated = z.literal('liquidated');

export const LoanStatus = z.union([
  LoanStatusPendingActivation,
  LoanStatusPreActive,
  LoanStatusActive,
  LoanStatusArchived,
  LoanStatusPendingTransfer,
  LoanStatusTransferred,
  LoanStatusPaidOff,
  LoanStatusReo, // Real estate owned (lender owns the property and no longer bills monthly statements)
  LoanStatusLiquidated,
]);
export type LoanStatus = z.infer<typeof LoanStatus>;

export const LoanStatusApi = z.union([
  LoanStatusPendingActivation,
  // LoanStatusPreActive, // API does not show pre-active status
  LoanStatusActive,
  LoanStatusArchived,
  LoanStatusPendingTransfer,
  LoanStatusTransferred,
  LoanStatusPaidOff,
  LoanStatusReo, // Real estate owned (lender owns the property and no longer bills monthly statements)
  LoanStatusLiquidated,
]);
export type LoanStatusApi = z.infer<typeof LoanStatusApi>;

export const TransferringLoanStatus = z.union([LoanStatusPendingTransfer, LoanStatusTransferred]);

export const LoanStatusesToIncrementAmortizationMonth = z.union([
  LoanStatusPreActive,
  LoanStatusActive,
  LoanStatusPendingTransfer,
  LoanStatusPendingActivation,
]);

/**
 * Loans that don't amortize or have an associated monthly payment
 */
export const InactiveLoanStatus = z.union([LoanStatusArchived, LoanStatusPaidOff, LoanStatusReo, LoanStatusLiquidated]);

/**
 * Allowed loan statuses at boarding
 */
const BoardedLoanStatus = ['active', 'preActive', 'pendingActivation'] as const satisfies readonly LoanStatus[];
export type BoardedLoanStatus = (typeof BoardedLoanStatus)[number];

/*
  These loan statuses should not have any borrower or external recipient emails sent
*/
export const OmitFromEmailLoanStatus = z.union([LoanStatusArchived, LoanStatusReo, LoanStatusLiquidated]);
export type OmitFromEmailLoanStatus = z.infer<typeof OmitFromEmailLoanStatus>;
